export default "__VITE_ASSET__3132ac8f__"